<div class="container-fluid mt-4">
    <div class="card">
        <div class="card-header">
            <div class="d-flex align-items-center">
                <h5 class="election-title">Amendments</h5>


            </div>
            <button class="btn btn-primary btn-sm ms-auto" (click)="addAmendments()"
                *ngIf="societyregistration && approveLastAmendment">
                Add New Amendment
            </button>
        </div>

        <div class="card-body">
            <div class="overflow-auto" *ngIf="AmendmentsList && AmendmentsList.length > 0">
                <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover"
                    [rows]="AmendmentsList" [columns]="columns" [headerHeight]="50" [footerHeight]="50"
                    [rowHeight]="'auto'" [limit]="5" [externalPaging]="true" [count]="AmendmentsList.length"
                    [offset]="page.pageNumber" [limit]="page.pageSize" (page)="setPage($event)" [columnMode]="'force'"
                    [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true">




                    <!-- Static Columns -->
                    <ngx-datatable-column name="#" prop="index" [sortable]="false" [width]="40">
                        <ng-template let-row="row" ngx-datatable-cell-template let-rowIndex="rowIndex">
                            {{ rowIndex +1 }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Date" prop="Date" [sortable]="true" [width]="80">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.Date | date}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Total Amendments" prop="TotalAmmendments" [sortable]="true"
                        [width]="120">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.TotalAmmendments }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Amendments To Add" prop="AmmendmentsToAdded" [sortable]="true"
                        *ngIf="this.societyDetails.iSocietyId == 2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.AmmendmentsToAdded }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Amendments To Change" prop="AmmendmentsToChange" [sortable]="true"
                        *ngIf="this.societyDetails.iSocietyId == 2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.AmmendmentsToChange }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Amendments To Remove" prop="AmmendmentsToRemove" [sortable]="true"
                        *ngIf="this.societyDetails.iSocietyId == 2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.AmmendmentsToRemove }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Status" prop="sAuditStatus" [sortable]="true">
                        <ng-template let-row="row" ngx-datatable-cell-template>

                            <span [ngClass]="
                     row.sAuditStatus === 'Approved' ?'badge bg-success':
                     row.sAuditStatus === 'Pending'?  'badge bg-warning':
                     row.sAuditStatus === 'Rejected'?  'badge bg-danger':''
">
                                {{ row?.sAuditStatus }}
                            </span>

                        </ng-template>
                    </ngx-datatable-column>
                    <!-- <ngx-datatable-column name="Fee" prop="FeeAmount" [sortable]="true"  *ngIf="this.societyDetails.iSocietyId == 1">
                <ng-template let-row="row" ngx-datatable-cell-template>

      <span
  class="badge d-inline-flex align-items-center gap-1 px-2 py-1"
  [ngClass]="row?.IsPaid == 1
    ? 'bg-success-subtle text-success border border-success-subtle'
    : 'bg-warning-subtle text-warning border border-warning-subtle'">

  <i
    class="bi"
    [ngClass]="row?.IsPaid == 1
      ? 'bi-check-circle-fill'
      : 'bi-clock-history'">
  </i>

  {{ row?.FeeAmount }}
</span>


                </ng-template>
            </ngx-datatable-column> -->



                    <ngx-datatable-column name="Fee" prop="FeeAmount" [sortable]="true"
                        *ngIf="societyDetails.iSocietyId == 1">
                        <ng-template let-row="row" ngx-datatable-cell-template>

                            <!-- 💰 Fee Badge -->
                            <span class="badge d-inline-flex align-items-center gap-1 px-2 py-1 me-2" [ngClass]="row?.IsPaid == 1
        ? 'bg-success-subtle text-success border border-success-subtle'
        : 'bg-warning-subtle text-warning border border-warning-subtle'">

                                <i class="bi" [ngClass]="row?.IsPaid == 1
          ? 'bi-check-circle-fill'
          : 'bi-clock-history'">
                                </i>

                                ₹ {{ row?.FeeAmount ? row?.FeeAmount:'NA' }}
                            </span>

                            <!-- ✅ Paid UI -->
                            <span *ngIf="row?.IsPaid == 1"
                                class="badge bg-success d-inline-flex align-items-center gap-1 px-2 py-1">

                                <i class="bi bi-patch-check-fill"></i>
                                Payment Done
                            </span>

                            <!-- 🚀 Pay Now Button -->
                            <button *ngIf="row?.IsPaid != 1 &&  row?.FeeAmount" class="btn btn-sm btn-primary shadow-sm"
                                (click)="payNow(row)">

                                <i class="bi bi-credit-card me-1"></i>
                                Pay Now
                            </button>

                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Action" prop="Action" [sortable]="false">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <div class="d-flex align-items-center gap-2">
                                <a href="javascript:void(0)" class="btn btn-info btn-sm"
                                    (click)="getApplicationDetail(row)"> <i class="fa fa-eye"></i>
                                </a>
                                <button *ngIf="row?.sAssistantRegistrarDocument"
                                    type="button"
                                    class="btn btn-success btn-sm"
                                    title="Download Certificate"
                                    (click)="downloadDocument(row.sAssistantRegistrarDocument)">
                                    <i class="bi bi-download" aria-hidden="true"></i>
                                </button>
                                <button *ngIf="row?.IsCompleted == 2 && this.societyDetails.iSocietyId == 2 "
                                    class="btn btn-primary btn-sm" title="Download Order"
                                    (click)="getByLawsOrderCertificate(row)"><i class="bi bi-download"
                                        aria-hidden="true"></i></button>
                                <!-- <button
                                    *ngIf="row?.IsCompleted == 2  && this.societyDetails.iSocietyId == 1 && row?.IsVerify == 1"
                                    class="btn btn-primary btn-sm" title="Download Order"
                                    (click)="getByLawsOrderCertificate(row)"><i class="bi bi-download"
                                        aria-hidden="true"></i></button> -->
                                <!-- data-bs-toggle="modal" data-bs-target="#AmendmentsOrderDetails" -->
                                <!-- <button *ngIf="row?.IsCompleted == 7" class="btn btn-sm btn-primary" (click)="editAmendments(row)" >
                                     <i class="bi bi-pencil"></i>
                                </button> -->
                                <button *ngIf="canEditAmendment(row)" class="btn btn-sm btn-primary"
                                    (click)="editAmendments(row)" title="Edit">
                                    <i class="fa fa-pencil"></i>
                                </button>

                                                   <div *ngIf=" row?.sAmendmentCertificate != null" class="d-flex align-items-center gap-2">

                             

                              <button  *ngIf=" row?.sAmendmentCertificate != null &&  this.societyDetails.iSocietyId == 1 "  class="btn btn-success btn-sm "
                                (click)="downloadFile(row?.sAmendmentCertificate)">
                                <i class="bi bi-download me-1"></i>
                             
                              </button>

                            </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>



                </ngx-datatable>
            </div>
            <div class="overflow-auto noData-container p-2" *ngIf="AmendmentsList && AmendmentsList.length == 0">
                <span> No Amendment Available</span>
            </div>
        </div>
    </div>

    <!-- ========================= MODAL ========================= -->

    <div class="modal fade" id="AmendmentsAppDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="AmendmentsAppDetailsLabel" aria-hidden="true">

        <div class="modal-dialog modal-xl modal-dialog-scrollable">

            <div class="modal-content border-0 rounded-4 shadow-lg overflow-hidden">

                <!-- HEADER -->
                <div class="modal-header bg-white border-bottom px-4 py-3">

                    <div class="w-100 d-flex justify-content-between align-items-center flex-wrap gap-3">

                        <div>
                            <h3 class="fw-bold text-primary mb-1">
                                <i class="bi bi-file-earmark-text me-2"></i>
                                Amendments Application
                            </h3>

                            <div class="text-muted small">
                                Submitted Date :
                                <span class="fw-semibold">
                                    {{aplicationDetailList?.selectedRow?.Date | date:'dd/MM/yyyy'}}
                                </span>
                            </div>
                        </div>

                        <div class="d-flex align-items-center gap-2 flex-wrap">

                            <button class="btn rounded-pill px-4"
                                [ngClass]="applicationModel == 1 ? 'btn-primary' : 'btn-outline-primary'"
                                (click)="toggle(1)">

                                <i class="bi bi-card-list me-1"></i>
                                Application Details

                            </button>

                            <button class="btn rounded-pill px-4" *ngIf="currentUser.roleId == 13"
                                [ngClass]="applicationModel == 2 ? 'btn-success' : 'btn-outline-success'"
                                (click)="toggle(2)">

                                <i class="bi bi-patch-check me-1"></i>
                                Amendment Accepted

                            </button>

                            <button class="btn rounded-pill px-4"
                                [ngClass]="applicationModel == 3 ? 'btn-warning text-dark' : 'btn-outline-warning'"
                                (click)="toggle(3)">

                                <i class="bi bi-clock-history me-1"></i>
                                Status Details

                            </button>

                            <button type="button" class="btn-close ms-2" data-bs-dismiss="modal">
                            </button>

                        </div>

                    </div>

                </div>

                <!-- BODY -->
                <div class="modal-body bg-light p-4">

                    <!-- ================================================= -->
                    <!-- APPLICATION DETAILS -->
                    <!-- ================================================= -->

                    <div *ngIf="applicationModel == 1">

                        <!-- DOCUMENTS -->

                        <div class="card border-0 rounded-4 shadow-sm mb-4">

                            <div class="card-body p-4">

                                <div class="d-flex justify-content-between align-items-center mb-4">

                                    <h5 class="fw-bold mb-0 text-dark">
                                        <i class="bi bi-folder2-open me-2 text-primary"></i>
                                        Uploaded Documents
                                    </h5>

                                </div>

                                <div class="row g-3">

                                    <div class="col-md-6 col-lg-3">

                                        <div class="border rounded-4 p-3 bg-white h-100">

                                            <div class="d-flex flex-column align-items-center text-center">

                                                <i class="bi bi-file-earmark-pdf fs-1 text-danger mb-2"></i>

                                                <h6 class="fw-semibold mb-3">
                                                    Proceeding Meeting
                                                </h6>

                                                <button type="button" class="btn btn-primary btn-sm rounded-pill px-4"
                                                    (click)="downloadFile(aplicationDetailList?.fileProceedingGHMPath)">

                                                    <i class="bi bi-download me-1"></i>
                                                    Download

                                                </button>

                                            </div>

                                        </div>

                                    </div>

                                    <div class="col-md-6 col-lg-3">

                                        <div class="border rounded-4 p-3 bg-white h-100">

                                            <div class="d-flex flex-column align-items-center text-center">

                                                <i class="bi bi-file-earmark-text fs-1 text-info mb-2"></i>

                                                <h6 class="fw-semibold mb-3">
                                                    Meeting Notice
                                                </h6>

                                                <button type="button" class="btn btn-primary btn-sm rounded-pill px-4"
                                                    (click)="downloadFile(aplicationDetailList?.fileNoticeGHMPath)">

                                                    <i class="bi bi-download me-1"></i>
                                                    Download

                                                </button>

                                            </div>

                                        </div>

                                    </div>

                                    <div class="col-md-6 col-lg-3">

                                        <div class="border rounded-4 p-3 bg-white h-100">

                                            <div class="d-flex flex-column align-items-center text-center">

                                                <i class="bi bi-people fs-1 text-success mb-2"></i>

                                                <h6 class="fw-semibold mb-3">
                                                    Attendance Sheet
                                                </h6>

                                                <button type="button" class="btn btn-primary btn-sm rounded-pill px-4"
                                                    (click)="downloadFile(aplicationDetailList?.fileMemberPresentPath)">

                                                    <i class="bi bi-download me-1"></i>
                                                    Download

                                                </button>

                                            </div>

                                        </div>

                                    </div>

                                    <div class="col-md-6 col-lg-3">

                                        <div class="border rounded-4 p-3 bg-white h-100">

                                            <div class="d-flex flex-column align-items-center text-center">

                                                <i class="bi bi-journal-text fs-1 text-warning mb-2"></i>

                                                <h6 class="fw-semibold mb-3">
                                                    Annotated Form
                                                </h6>

                                                <button type="button" class="btn btn-primary btn-sm rounded-pill px-4"
                                                    (click)="downloadFile(aplicationDetailList?.fileProposedAmmendmentPath)">

                                                    <i class="bi bi-download me-1"></i>
                                                    Download

                                                </button>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>


                        <div class="card border-0 shadow-lg rounded-4 overflow-hidden">

                            <!-- CARD HEADER -->

                            <div class="card-header bg-white border-0 px-4 py-4">

                                <div class="d-flex justify-content-between align-items-start flex-wrap gap-3 w-100">

                                    <!-- Left Content -->
                                    <div class="d-flex align-items-center gap-3">

                                        <div class="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center"
                                            style="width:55px;height:55px; min-width:55px;">

                                            <i class="bi bi-journal-text text-primary fs-4"></i>

                                        </div>

                                        <div>
                                            <h4 class="fw-bold mb-1 text-dark">
                                                Amendments Details
                                            </h4>

                                            <p class="text-muted mb-0 small">
                                                Complete list of proposed amendments in by-laws
                                            </p>
                                        </div>

                                    </div>

                                    <!-- Right Corner Badge -->
                                    <div class="ms-auto">
                                        <div class="badge bg-primary rounded-pill px-4 py-3 fs-6 shadow-sm">
                                            <i class="bi bi-collection me-1"></i>
                                            Total Amendments :
                                            {{aplicationDetailList?.byLawsDetails?.length || 0}}
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <!-- CARD BODY -->

                            <div class="card-body bg-light-subtle p-4">

                                <!-- EMPTY STATE -->

                                <div *ngIf="!aplicationDetailList?.byLawsDetails?.length" class="text-center py-5">

                                    <div class="mb-3">

                                        <i class="bi bi-inbox text-muted" style="font-size: 70px;"></i>

                                    </div>

                                    <h5 class="fw-bold text-muted">
                                        No Amendments Available
                                    </h5>

                                    <p class="text-muted mb-0">
                                        No amendment records found for this application.
                                    </p>

                                </div>

                                <!-- TABLE -->

                                <div class="col-lg-12">
                                    <h5 class="election-title">Amendments</h5>
                                    <div class="table-responsive"
                                        *ngIf="aplicationDetailList?.byLawsDetails && aplicationDetailList?.byLawsDetails.length>0">
                                        <ngx-datatable #amendmentsDetailTable
                                            class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                            [rows]="aplicationDetailList?.byLawsDetails" [columns]="columns"
                                            [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [limit]="10"
                                            [count]="aplicationDetailList?.byLawsDetails.length" [columnMode]="'force'"
                                            [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true"
                                            [externalPaging]="false"
                                            style="min-height: 280px; width: 100%">
                                            <ngx-datatable-column name="#" prop="index">
                                                <ng-template let-row="row" ngx-datatable-cell-template
                                                    let-rowIndex="rowIndex">
                                                    {{ rowIndex +1 }}
                                                </ng-template>
                                            </ngx-datatable-column>


                                            <ngx-datatable-column name="Amendment Type" prop="amendmentType">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    {{typeName(row?.sAmmendmentTypeSubject||null )}}

                                                </ng-template>
                                            </ngx-datatable-column>
                                            <ngx-datatable-column name="Amendment Action Type" prop="amendmentType">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    {{ getAmendmentActionLabel(row) }}
                                                </ng-template>
                                            </ngx-datatable-column>
                                            <ngx-datatable-column name="Bylaws Number" prop="sByLawsNo">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    {{ row.sByLawsNo }}
                                                </ng-template>
                                            </ngx-datatable-column>

                                            <ngx-datatable-column name="New By-laws" prop="sNewByLawsDetail">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    <!-- {{ row.sNewByLawsDetail }} -->
                                                    <app-read-more
                                                        text="{{row.sNewByLawsDetail ?row.sNewByLawsDetail:'NA'}}"
                                                        [maxLength]="15" (viewMore)="viewMore($event)"></app-read-more>
                                                </ng-template>
                                            </ngx-datatable-column>
                                            <ngx-datatable-column name="Existing By-Laws" prop="sExistByLawsDetail">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    <!-- {{ row.sNewByLawsDetail }} -->
                                                    <app-read-more
                                                        text="{{row.sExistByLawsDetail ?row.sExistByLawsDetail:'NA'}}"
                                                        [maxLength]="15" (viewMore)="viewMore($event)"></app-read-more>
                                                </ng-template>
                                            </ngx-datatable-column>



                                        </ngx-datatable>

                                    </div>

                                </div>

                            </div>

                        </div> <!-- DECLARATION -->

                        <div class="card border-0 rounded-4 shadow-sm mt-4">

                            <div class="card-body p-4">

                                <h5 class="fw-bold mb-4 text-dark">
                                    <i class="bi bi-shield-check me-2 text-success"></i>
                                    Declaration
                                </h5>

                                <div class="form-check mb-3">

                                    <input class="form-check-input" type="checkbox" checked disabled>

                                    <label class="form-check-label text-muted">

                                        The amendments in the by-laws have been approved
                                        in the general meeting where quorum was present.

                                    </label>

                                </div>

                                <div class="form-check">

                                    <input class="form-check-input" type="checkbox" checked disabled>

                                    <label class="form-check-label text-muted">

                                        Due notice and agenda related to amendment of by-laws
                                        was circulated to all members.

                                    </label>

                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- ================================================= -->
                    <!-- STATUS DETAILS -->
                    <!-- ================================================= -->

                    <div class="col-lg-12" *ngIf="applicationModel ==3">
                        <div class="row">
                            <div class="col-lg-12">
                                <h6 class="election-title">Amendments Application Status</h6>
                            </div>
                            <div class="col-lg-5">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="step-progressbar">
                                            <div class="v-progress progress-area">
                                                <ul>

                                                    <li *ngFor="let item of bylawsProgress"
                                                        [class]="item?.ProgressClass">{{item?.AuditStatus}} - <small
                                                            style="font-size: 12px;">{{item?.dCreatedDate |
                                                            date:"dd/MM/yyyy"}}</small> <br>
                                                        <b style="font-size: 12px;">( {{item?.RoleName}} )</b>
                                                        <!-- Society User: only BI Send Back remark -->
                                                        <a *ngIf="canShowSocietyBiViewRemark(item)"
                                                            href="javascript:void(0)"
                                                            class="ms-2 text-primary fw-semibold text-decoration-none"
                                                            style="font-size: 12px;"
                                                            (click)="viewTimelineRemark(item)"
                                                            title="View Remark">
                                                            <i class="fa fa-clipboard me-1"></i>View Remark
                                                        </a>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
    <div class="col-lg-6" >
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">

                                                <!-- Society User: no Filter/Update — only BI Send Back remark preview -->
                                                <ng-container *ngIf="currentUser?.roleId == 9; else officerFilterPanel">
                                                    <div class="col-lg-12 d-flex justify-content-between align-items-center mb-2">
                                                        <h5 class="mb-0">Remark</h5>
                                                        <button *ngIf="selectedRemarkDetails" type="button"
                                                            class="btn-close" aria-label="Close"
                                                            (click)="closeTimelineRemark()"></button>
                                                    </div>
                                                    <div class="col-12" *ngIf="selectedRemarkDetails; else noSocietyRemark">
                                                        <div class="p-3 rounded border position-relative"
                                                            style="background-color: #fff3cd;">
                                                            <label class="form-label fw-semibold mb-1">
                                                                Block Inspector — Send Back Remark
                                                            </label>
                                                            <div class="text-dark timeline-remark-body"
                                                                [class.text-muted]="selectedRemarkDetails?.remark === 'not remark added'"
                                                                [class.timeline-remark-body--collapsed]="isLongRemarkText(selectedRemarkDetails?.remark) && !remarkPreviewExpanded"
                                                                [class.timeline-remark-body--expanded]="isLongRemarkText(selectedRemarkDetails?.remark) && remarkPreviewExpanded">
                                                                {{ selectedRemarkDetails?.remark }}
                                                            </div>
                                                            <div class="timeline-remark-actions d-flex justify-content-between align-items-center mt-2">
                                                                <a *ngIf="isLongRemarkText(selectedRemarkDetails?.remark)"
                                                                    href="javascript:void(0)"
                                                                    class="timeline-remark-toggle"
                                                                    (click)="toggleRemarkPreviewExpand()">
                                                                    {{ remarkPreviewExpanded ? 'Show less' : 'Read more' }}
                                                                </a>
                                                                <span *ngIf="!isLongRemarkText(selectedRemarkDetails?.remark)"></span>
                                                                <a *ngIf="selectedRemarkDetails?.FilePath"
                                                                    href="javascript:void(0)"
                                                                    class="btn btn-outline-info btn-sm ms-auto"
                                                                    (click)="downloadFile(selectedRemarkDetails.FilePath)">
                                                                    Download Document
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ng-template #noSocietyRemark>
                                                        <div class="col-12 text-muted small">
                                                            Click <strong>View Remark</strong> on a Block Inspector
                                                            Send Back entry to see the remark.
                                                        </div>
                                                    </ng-template>
                                                </ng-container>

                                                <ng-template #officerFilterPanel>
                                                <div class="col-lg-12">
                                                    <h5>Filter</h5>
                                                </div>
                                                <form [formGroup]="updateStatusForm">
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 mb-3">
                                                            <label class="form-label">Select Role</label>
                                                            <select class="form-control" formControlName="role"
                                                                aria-placeholder="Select Role"
                                                                (change)="changeRole($event)">
                                                                <option selected disabled value="">Select Role</option>
                                                                <option *ngFor="let role of roles"
                                                                    [value]="role?.RoleId">
                                                                    {{role?.RoleName}}</option>
                                                            </select>
                                                        </div>
                                                        <div
                                                            class="col-lg-6 col-md-6 mb-3 d-flex justify-content-center align-items-center">
                                                            <div *ngIf="selectedRemarkDetails?.FilePath" class="mt-4">

                                                                <a href="javascript:void(0)"
                                                                    class=" btn btn-outline-info float-end"
                                                                    (click)="downloadFile(selectedRemarkDetails.FilePath)">Download
                                                                    Document </a>
                                                            </div>
                                                        </div>

                                                        <div *ngIf="selectedRemarkDetails">

                                                            <div *ngIf="selectedRemarkDetails?.remark">
                                                                <label class="form-label">Remarks</label>
                                                                <textarea class="form-control"
                                                                    [value]="selectedRemarkDetails?.remark"
                                                                    disabled="true"
                                                                    placeholder="Please Enter Remark Here..."
                                                                    rows="4"></textarea>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </form>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>

    <!-- ========================= VIEW MORE MODAL ========================= -->

    <div class="modal fade" id="readMoreModal" tabindex="-1" aria-hidden="true">

        <div class="modal-dialog modal-lg modal-dialog-scrollable">

            <div class="modal-content rounded-4 border-0 shadow-lg">

                <div class="modal-header border-bottom">

                    <h5 class="modal-title fw-bold text-primary">
                        Full Details
                    </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal">
                    </button>

                </div>

                <div class="modal-body">

                    <div class="lh-lg text-dark" style="white-space: pre-line;">

                        {{ ExpendeText }}

                    </div>

                </div>

            </div>

        </div>

    </div>
   <div class="modal fade" id="AmendmentsAppDetails2006" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="AmendmentsAppDetails2006Label" aria-hidden="true">

        <div class="modal-dialog modal-xl modal-dialog-scrollable">

            <div class="modal-content border-0 rounded-4 shadow-lg overflow-hidden">

                <!-- HEADER -->
                <div class="modal-header bg-white border-bottom px-4 py-3">

                    <div class="w-100 d-flex justify-content-between align-items-center flex-wrap gap-3">

                        <div>
                            <h3 class="fw-bold text-primary mb-1">
                                <i class="bi bi-file-earmark-text me-2"></i>
                                Amendments Application
                            </h3>

                            <div class="text-muted small">
                                Submitted Date :
                                <span class="fw-semibold">
                                    {{aplicationDetailList?.selectedRow?.Date | date:'dd/MM/yyyy'}}
                                </span>
                            </div>
                        </div>

                        <div class="d-flex align-items-center gap-2 flex-wrap">

                            <button class="btn rounded-pill px-4"
                                [ngClass]="applicationModel == 1 ? 'btn-primary' : 'btn-outline-primary'"
                                (click)="toggle(1)">

                                <i class="bi bi-card-list me-1"></i>
                                Application Details

                            </button>

                           

                            <button class="btn rounded-pill px-4"
                                [ngClass]="applicationModel == 3 ? 'btn-warning text-dark' : 'btn-outline-warning'"
                                (click)="toggle(3)">

                                <i class="bi bi-clock-history me-1"></i>
                                Status Details

                            </button>

                            <button type="button" class="btn-close ms-2" data-bs-dismiss="modal" (click)="closeModal()">
                            </button>

                        </div>

                    </div>

                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-lg-12" *ngIf="applicationModel==1">
                            <div>

                                <div id="printSection" class="print-container">

                                    <div class="d-flex justify-content-end align-items-center mb-3 no-print">

                                        <button class="btn btn-primary" (click)="printForm()">
                                            <i class="bi bi-printer me-1"></i>
                                            Print
                                        </button>

                                    </div>

                                    <div class="card">
                                        <h4 class="election-title text-center ">
                                            Amendments Application Details
                                        </h4>
                                        <table>
                                            <tr>
                                                <td><b>Amendment ID</b></td>
                                                <td>{{ aplicationDetailList?.selectedRow?.iByLawsId || '-' }}</td>
                                                <td><b>Amendment Count (Till Date)</b></td>
                                                <td>
                                                    {{ totalAmendmentCount || '-' }}
                                                </td>
                                                <td><b>Printed On</b></td>
                                                <td>{{ printDate | date:'dd/MM/yyyy hh:mm a' }}</td>
                                            </tr>
                                        </table>
                                    </div>

                                    <div class="card mt-3">

                                        <div class="election-title">Details of the Authorized Person</div>

                                        <table>
                                            <tr>
                                                <td><b>👤 Name</b></td>
                                                <td>{{ aplicationDetailList?.user?.firstName || '-' }}</td>
                                            </tr>

                                            <tr>
                                                <td><b>🏠 Address</b></td>
                                                <td>{{ aplicationDetailList?.user?.address || '-' }}</td>
                                            </tr>

                                            <tr>
                                                <td><b>📞 Mobile</b></td>
                                                <td>{{ aplicationDetailList?.user?.mobile || '-' }}</td>
                                            </tr>

                                            <tr>
                                                <td><b>✉️ Email</b></td>
                                                <td>{{ aplicationDetailList?.user?.email || '-' }}</td>
                                            </tr>
                                        </table>
                                    </div>

                                    <!-- ================= AMENDMENTS ================= -->
                                    <div class="card mt-3" *ngIf="amendmentsList?.length">
                                        <div class="election-title">Amendments Proposed in</div>

                                        <table class="custom-table">
                                            <tr *ngFor="let item of amendmentsList; let i = index">
                                                <td class="index">{{ i + 1 }}.</td>
                                                <td class="label"><b>{{ getAmendmentName(item.amendmentType) }}</b></td>
                                                <td class="value">
                                                    Resolution No. <b>{{ item.resolutionNo }}</b>
                                                    <span>(dated <b>{{ item.resolutionDate | date:'dd/MM/yyyy'
                                                            }}</b>)</span>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div *ngFor="let group of groupedBylaws">
                                        <!-- TASK: hide Proposed section when empty — undo if manager asks to revert -->
                                        <div class="card mt-3" *ngIf="groupHasProposed(group)">

                                            <div class="election-title">
                                                Amendments in {{ getAmendmentName(group.amendmentType) }}
                                            </div>

                                            <table>

                                                <thead>
                                                    <tr>
                                                        <th><b>Existing</b></th>
                                                        <th><b>Proposed</b></th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    <ng-container *ngFor="let item of group.bylaws">

                                                        <tr *ngIf="hasProposedContent(item.proposedChange)">

                                                            <td>{{ item.existingDetails || '-' }}</td>

                                                            <td>{{ item.proposedChange }}</td>


                                                        </tr>

                                                    </ng-container>

                                                </tbody>

                                            </table>

                                        </div>

                                    </div>
                                    <!-- ================= GENERAL BODY MEMBERS ================= -->
                                    <div class="card mt-3" *ngIf="societyMemberList?.length">

                                        <div class="election-title">General Body Members</div>

                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Age</th>
                                                    <th>Gender</th>
                                                    <th>Father/Husband</th>
                                                    <th>Address</th>
                                                    <th>Occupation</th>
                                                    <th>Type of Member</th>
                                                    <th>Fee / Challan</th>
                                                    <th>Designation</th>
                                                    <th>Document</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr *ngFor="let item of societyMemberList; let i = index">

                                                    <td>{{ i + 1 }}</td>
                                                    <td>{{ item.sMemName }}</td>
                                                    <td>{{ item.sMemAge }}</td>
                                                    <td>{{ item.sGender }}</td>

                                                    <td>
                                                        {{
                                                        item.sGender === 'Male'
                                                        ? item.sFatherName
                                                        : item.sMaritalStatus === 'Married'
                                                        ? item.sMemHusName
                                                        : item.sFatherName
                                                        }}
                                                    </td>

                                                    <td>{{ item.sAdd1 }} {{ item.sAdd2 }}</td>
                                                    <td>{{ item.sOccupation }}</td>
                                                    <td>{{ item.sMembershiptypename }}</td>
                                                    <td>{{ item.sMemShipFee || 'N/A' }}</td>
                                                    <td>{{ item.sMemberDesignation }}</td>

                                                    <td>
                                                        <button class="no-print btn btn-success btn-sm"
                                                            (click)="downloadFile(item.sUploadAadharCardPath)">
                                                            <i class="bi bi-download me-1"></i>

                                                        </button>

                                                        <span class="print-only">Document Attached</span>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- ================= GOVERNING BODY ================= -->
                                    <div class="card mt-3" *ngIf="societyMemberList?.length">

                                        <div class="election-title">Governing Body Members</div>

                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Designation</th>
                                                    <th>Gender</th>
                                                    <th>Occupation</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr *ngFor="let item of filteredGoverningMembers; let i = index">

                                                    <td>{{ i + 1 }}</td>
                                                    <td>{{ item.sMemName }}</td>
                                                    <td>{{ item.sMemberDesignation }}</td>
                                                    <td>{{ item.sGender }}</td>
                                                    <td>{{ item.sOccupation }}</td>

                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <!-- ================= DOCUMENTS ================= -->
                                    <div class="card mt-3">

                                        <div class="election-title">Requisite Documents</div>

                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Document</th>
                                                    <th>Attachment</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr *ngFor="let key of Uploadedkeys; let i = index">

                                                    <td>{{ i + 1 }}</td>
                                                    <td>{{ formatLabel(key) }}</td>

                                                    <td>
                                                        <button class="no-print btn btn-success btn-sm"
                                                            (click)="downloadFile(uploadedFiles[key])">
                                                            <i class="bi bi-download me-1"></i>

                                                        </button>

                                                        <span class="print-only">Document Attached</span>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                </div>
                            </div>


                        </div>

                        <div class="col-lg-12" *ngIf="applicationModel == 2">
                            <div>
                                <div>
                                    <h6 class="election-title">Select Amendments for Orders</h6>

                                    <div class="table-responsive ">

                                        <ngx-datatable
                                            class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                            [rows]="orderData" [columns]="orderColumns" [columnMode]="'force'"
                                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                                            [columnMode]="'force'" [selected]="selected"
                                            [selectionType]="SelectionType.checkbox" (select)='onSelect($event)'
                                            [virtualization]="false" [scrollbarV]="true" [scrollbarH]="false">
                                            <!-- Column Definitions -->
                                            <!-- Column Definitions -->
                                            <ngx-datatable-column name="#" prop="index" [sortable]="false"
                                                [maxWidth]="60">
                                                <ng-template let-row="row" ngx-datatable-cell-template
                                                    let-rowIndex="rowIndex">
                                                    {{ rowIndex +1 }}
                                                </ng-template>
                                            </ngx-datatable-column>

                                            <ngx-datatable-column name="ByLaws Number" prop="sByLawsNo"
                                                [sortable]="true" [maxWidth]="200">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    {{ row.sByLawsNo}}
                                                </ng-template>
                                            </ngx-datatable-column>
                                            <ngx-datatable-column name="New By-laws" prop="sNewByLawsDetail">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    <!-- {{ row.sNewByLawsDetail }} -->
                                                    <app-read-more
                                                        text="{{row.sNewByLawsDetail ?row.sNewByLawsDetail:'NA'}}"
                                                        [maxLength]="15" (viewMore)="viewMore($event)"></app-read-more>
                                                </ng-template>
                                            </ngx-datatable-column>
                                            <ngx-datatable-column name="Existing By-Laws" prop="sExistByLawsDetail">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    <!-- {{ row.sNewByLawsDetail }} -->
                                                    <app-read-more
                                                        text="{{row.sExistByLawsDetail ?row.sExistByLawsDetail:'NA'}}"
                                                        [maxLength]="15" (viewMore)="viewMore($event)"></app-read-more>
                                                </ng-template>
                                            </ngx-datatable-column>
                                            <ngx-datatable-column [width]="30" [sortable]="false"
                                                [canAutoResize]="false" [draggable]="false" [resizeable]="false"
                                                [headerCheckboxable]="true">
                                                <!-- <ng-template
                                        ngx-datatable-header-template
                                        let-allRowsSelected="allRowsSelected"
                                        let-selectFn="selectFn"
                                      >
                                        <input type="checkbox" [checked]="allRowsSelected" (change)="selectFn()" />
                                      </ng-template> -->
                                                <ng-template ngx-datatable-header-template
                                                    let-allRowsSelected="allRowsSelected" let-selectFn="selectFn">
                                                    <input type="checkbox" [checked]="allRowsSelected"
                                                        [disabled]="this.aplicationDetailList.selectedRow?.sAuditStatus == 'Approved'|| this.aplicationDetailList.selectedRow?.sAuditStatus == 'Rejected'"
                                                        (change)="selectFn()" />
                                                </ng-template>
                                                <ng-template ngx-datatable-cell-template let-value="value" let-row="row"
                                                    let-isSelected="isSelected"
                                                    let-onCheckboxChangeFn="onCheckboxChangeFn">
                                                    <input type="checkbox" [checked]="isSelected"
                                                        [disabled]="this.aplicationDetailList.selectedRow?.sAuditStatus == 'Approved'|| this.aplicationDetailList.selectedRow?.sAuditStatus == 'Rejected'"
                                                        (change)="onCheckboxChangeFn($event)" />
                                                </ng-template>
                                            </ngx-datatable-column>
                                        </ngx-datatable>
                                        <!-- <table class="table table-hover align-middle text-nowrap table-bordered">
                        <thead>
                            <tr>
                                <th class="text-dark font-medium">#</th>
                                <th class="text-dark font-medium">Bylaws Number</th>
                                <th class="text-dark font-medium">Bylaws</th>
                                <th class="text-dark font-medium text-center">
                                    <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersAll">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                            <td></td>
                            <td></td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersOne">
                            </td>
                            </tr>
                            <tr>
                                <td>2</td>
                            <td></td>
                            <td></td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersOne">
                            </td>
                            </tr>
                            <tr>
                                <td>3</td>
                            <td></td>
                            <td></td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersOne">
                            </td>
                            </tr>
                        </tbody>
                    </table> -->
                                    </div>

                                    <!-- <div class="text-end">
                                    <button type="button" class="btn btn-primary" (click)="orders()"> Order</button>
                                </div> -->
                                </div>
                            </div>
                        </div>


                        <div class="col-lg-12" *ngIf="applicationModel ==3">
                            <div class="row">
                                <div class="col-lg-12">
                                    <h6 class="election-title">Amendments Application Status</h6>
                                </div>
                                <div class="col-lg-5">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="step-progressbar">
                                                <div class="v-progress progress-area">
                                                    <ul>

                                                        <li *ngFor="let item of bylawsProgress"
                                                            [class]="item?.ProgressClass">{{item?.AuditStatus}} - <small
                                                                style="font-size: 12px;">{{item?.dCreatedDate |
                                                                date:"dd/MM/yyyy"}}</small> <br>
                                                            <b style="font-size: 12px;">( {{item?.RoleName}} )</b>
                                                            <!-- Society 2006: View Remark on Dealing Hand Send Back only -->
                                                            <a *ngIf="canShowSocietyBiViewRemark(item)"
                                                                href="javascript:void(0)"
                                                                class="ms-2 text-primary fw-semibold text-decoration-none"
                                                                style="font-size: 12px;"
                                                                (click)="viewTimelineRemark(item)"
                                                                title="View Remark">
                                                                <i class="fa fa-clipboard me-1"></i>View Remark
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    <div class="col-lg-6" >
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">

                                                <!-- Society User 2006: remark preview (DH Send Back only) -->
                                                <ng-container *ngIf="currentUser?.roleId == 9; else officerFilter2006">
                                                    <div class="col-lg-12 d-flex justify-content-between align-items-center mb-2">
                                                        <h5 class="mb-0">Remark</h5>
                                                        <button *ngIf="selectedRemarkDetails" type="button"
                                                            class="btn-close" aria-label="Close"
                                                            (click)="closeTimelineRemark()"></button>
                                                    </div>
                                                    <div class="col-12" *ngIf="selectedRemarkDetails; else noSocietyRemark2006">
                                                        <div class="p-3 rounded border position-relative"
                                                            style="background-color: #fff3cd;">
                                                            <label class="form-label fw-semibold mb-1">
                                                                Dealing Hand — Send Back Remark
                                                            </label>
                                                            <div class="text-dark timeline-remark-body"
                                                                [class.text-muted]="selectedRemarkDetails?.remark === 'not remark added'"
                                                                [class.timeline-remark-body--collapsed]="isLongRemarkText(selectedRemarkDetails?.remark) && !remarkPreviewExpanded"
                                                                [class.timeline-remark-body--expanded]="isLongRemarkText(selectedRemarkDetails?.remark) && remarkPreviewExpanded">
                                                                {{ selectedRemarkDetails?.remark }}
                                                            </div>
                                                            <div class="timeline-remark-actions d-flex justify-content-between align-items-center mt-2">
                                                                <a *ngIf="isLongRemarkText(selectedRemarkDetails?.remark)"
                                                                    href="javascript:void(0)"
                                                                    class="timeline-remark-toggle"
                                                                    (click)="toggleRemarkPreviewExpand()">
                                                                    {{ remarkPreviewExpanded ? 'Show less' : 'Read more' }}
                                                                </a>
                                                                <span *ngIf="!isLongRemarkText(selectedRemarkDetails?.remark)"></span>
                                                                <a *ngIf="selectedRemarkDetails?.FilePath"
                                                                    href="javascript:void(0)"
                                                                    class="btn btn-outline-info btn-sm ms-auto"
                                                                    (click)="downloadFile(selectedRemarkDetails.FilePath)">
                                                                    Download Document
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ng-template #noSocietyRemark2006>
                                                        <div class="col-12 text-muted small">
                                                            Click <strong>View Remark</strong> on a Dealing Hand
                                                            Send Back entry to see the remark.
                                                        </div>
                                                    </ng-template>
                                                </ng-container>

                                                <ng-template #officerFilter2006>
                                                <div class="col-lg-12">
                                                    <h5>Filter</h5>
                                                </div>
                                                <form [formGroup]="updateStatusForm">
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 mb-3">
                                                            <label class="form-label">Select Role</label>
                                                            <select class="form-control" formControlName="role"
                                                                aria-placeholder="Select Role"
                                                                (change)="changeRole($event)">
                                                                <option selected disabled value="">Select Role</option>
                                                                <option *ngFor="let role of roles"
                                                                    [value]="role?.RoleId">
                                                                    {{role?.RoleName}}</option>
                                                            </select>
                                                        </div>
                                                        <div
                                                            class="col-lg-6 col-md-6 mb-3 d-flex justify-content-center align-items-center">
                                                            <div *ngIf="selectedRemarkDetails?.FilePath" class="mt-4">

                                                                <a href="javascript:void(0)"
                                                                    class=" btn btn-outline-info float-end"
                                                                    (click)="downloadFile(selectedRemarkDetails.FilePath)">Download
                                                                    Document </a>
                                                            </div>
                                                        </div>

                                                        <div *ngIf="selectedRemarkDetails">

                                                            <div *ngIf="selectedRemarkDetails?.remark">
                                                                <label class="form-label">Remarks</label>
                                                                <textarea class="form-control"
                                                                    [value]="selectedRemarkDetails?.remark"
                                                                    disabled="true"
                                                                    placeholder="Please Enter Remark Here..."
                                                                    rows="4"></textarea>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </form>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Read More Model -->
                        <div class="modal fade animate-fade" id="readMoreModal" tabindex="-1"
                            aria-labelledby="readMoreModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-scrollable">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title election-title" id="readMoreModalLabel">Full Text</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close" (click)="hideViewMore()"></button>
                                    </div>
                                    <div class="modal-body">
                                        {{ ExpendeText }}
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="hideViewMore()">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="modal fade" id="remarkDetails" tabindex="-1" aria-labelledby="remarkDetailsLabel"
                            aria-hidden="true">
                            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h1 class="modal-title fs-5" id="remarkDetailsLabel">Disclaimer Details</h1>
                                        <button type="button" class="btn-close" (click)="closeRemarkModel()"></button>

                                    </div>


                                    <div class="modal-body">
                                        <div class="card-body">
                                            <div class="step-progressbar">
                                                <div>
                                                    <div id="disclaimerList">
                                                        <ng-container>
                                                            <div class="col-md-12"
                                                                *ngFor="let option of disclamerOptions; let i = index">
                                                                <div class="form-check">
                                                                    <input type="checkbox" class="form-check-input"
                                                                        [checked]="option.iDisclaimerId"
                                                                        [disabled]="true">
                                                                    <label class="form-check-label">{{
                                                                        option.sDisclaimer
                                                                        }}</label>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="col-lg-12 col-md-6 mb-3" *ngIf="selectedRemarkDetails?.FilePath">
                          <label class="form-label"></label>
                          <a href="javascript:void(0)" class=" mt-5 btn btn-secondary"
                              (click)="downloadDocument(selectedRemarkDetails.FilePath)">Download
                              Document </a>
                      </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="AmendmentsOrderDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="AmendmentsAppDetailsLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <!-- <div class="modal-header">
                    <h1 class="modal-title fs-5" id="AmendmentsAppDetailsLabel">Order Details</h1> &nbsp;
                    <a target="_blank" (click)="print('ordercontent')" class="btn btn-primary btn-sm"><i
                            class="fa fa-print"></i></a>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        (click)="closeOrder()"></button>

                </div> -->
                <div class="modal-header d-flex justify-content-between align-items-center">

                    <h1 class="modal-title election-title fs-5" id="AmendmentsAppDetailsLabel">Order Details</h1> &nbsp;


                    <div class="d-flex align-items-center gap-2">
                        <a target="_blank" (click)="print('ordercontent')" class="btn btn-primary btn-sm"><i
                                class="fa fa-print"></i></a>

                        <button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal">
                            <i class="fa fa-times" (click)="closeOrder()"></i>
                        </button>
                    </div>

                </div>

                <div class="modal-body">
                    <div id="ordercontent">

                        <div class="center">
                            <!-- <strong>The Ekta Multipurpose Co-operative Society Ltd.</strong><br> -->
                            <strong>{{OrderCertiftcateData?.societyName}}</strong><br>
                            <small>Regd. No. {{OrderCertiftcateData?.societyRegistrationNo}}, dt.
                                {{OrderCertiftcateData?.approvedate}}</small><br>
                            <!-- <small>Regd. Off: Village Rampur, PO Sutanpur, Tehsil & Distt. Solan H.P. 173229</small><br><br> -->
                            <small>Regd. Off:{{OrderCertiftcateData?.societyAddress}}</small><br><br>
                            <strong>Amendment Proposal in the Bye-Laws of Society</strong>
                        </div>

                        <table>
                            <tr>
                                <th>Bye Laws</th>
                                <th>Existing</th>
                                <th>Proposed</th>
                            </tr>
                            <tr *ngFor="let bylaws of this.OrderCertiftcateData?.bylaws">
                                <td>({{bylaws?.sByLawsNo}})
                                <td>{{OrderCertiftcateData?.societyName}}&nbsp; : &nbsp; {{bylaws?.sExistByLawsDetail}}
                                </td>
                                <td>{{OrderCertiftcateData?.societyName}}&nbsp; : &nbsp;{{bylaws?.sNewByLawsDetail}}
                                </td>
                            </tr>
                            <!-- <tr>
                            <td>(2)<br>Membership</td>
                            <td>
                                कोई भी स्त्री एवं पुरुष जो <br>
                                (क) भारत का नागरिक हो। <br>
                                (ख) समाज का सदस्य बनने की इच्छा रखता हो। <br>
                                (ग) योग्य हो। <br>
                                (घ) प्रविष्टि शुल्क अदा करे। <br>
                                (ङ) निर्धारित अंश जमा करे। <br>
                                वह समाज का सदस्य हो सकता है।
                            </td>
                            <td>
                                कोई भी स्त्री जो <br>
                                (क) भारत की नागरिक हो। <br>
                                (ख) समाज की सदस्य बनने की इच्छुक हो। <br>
                                (ग) योग्य हो। <br>
                                (घ) प्रविष्टि शुल्क अदा करे। <br>
                                (ङ) निर्धारित अंश जमा करे। <br>
                                वह समाज की सदस्य हो सकती है।
                            </td>
                        </tr> -->
                        </table>

                        <p>Certified that:</p>
                        <ol>
                            <li>The application has complied with the provisions of the Co-operative Act & Rules made
                                thereunder.</li>
                            <li>The proposed amendments are not contrary to the Act & Rules.</li>
                            <li>The proposed amendments are suitable for carrying out the subjects/objects and for
                                ensuring
                                the successful conduct of the business of the society.</li>
                        </ol>

                        <p>
                            Further it is also certified that in the case of amendment of bye-laws No.1 & 7, the
                            provisions
                            of rule 8-A (8) of the H.P. Co-operative Societies Rules 1971 have been fully complied with.
                        </p>

                        <div class="signature">
                            <div>
                                <strong>Authorized Signatory<br>President</strong>
                            </div>
                            <div>
                                <strong>Authorized Signatory<br>Secretary</strong>
                            </div>
                            <div>
                                <strong>Registrar of Cooperative Societies<br>H.P. – 173206</strong>
                            </div>
                        </div>

                        <p class="note">Amended on date: 7th March 2023</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div id="certificate">

  <ng-container [ngSwitch]="type">


    <div *ngSwitchCase="'name'" class="page">
        
      <app-certificate [data]="data"></app-certificate>
    </div>

    <div *ngSwitchCase="'bylaws'" class="page">
      <app-certificate [data]="data"></app-certificate>
    </div>
<div *ngSwitchCase="'Address'" class="page">
      <app-certificate [data]="data"></app-certificate>
    </div>

    
  </ng-container>

</div> -->


    <div class="modal fade" id="certificateDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="certificateDetailsLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">

            <div class="modal-content p-3">

                <div class="modal-header election-title">
                    <h5>Select Certificate</h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="row">
                    <div class="col-md-6 mb-3" *ngFor="let cert of certificateList">

                        <div class="card shadow-sm h-100 certificate-card" (click)="selectCertificate(cert)">

                            <div class="card-body d-flex justify-content-between align-items-center">

                                <!-- LEFT CONTENT -->
                                <div>
                                    <h6 class="mb-1 fw-bold">
                                        {{ cert.label }}
                                    </h6>

                                    <small class="text-muted">
                                        Registration No: {{ cert.regNo }}
                                    </small>
                                </div>

                                <!-- RIGHT ICON -->
                                <div>
                                    <i class="bi bi-arrow-right-circle fs-4 text-primary"></i>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button> -->

            </div>
        </div>
    </div>
    <div class="modal fade" id="openCertificateDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="certificateDetailsLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">

                    <div class="modal-header d-flex justify-content-between align-items-center">

                        <h5 class="modal-title election-title mb-0">
                            {{ selectedCertificate?.label }}
                        </h5>

                        <div class="d-flex align-items-center gap-2">
                            <a target="_blank" (click)="print('certificates')" class="btn btn-primary btn-sm">
                                <i class="fa fa-print"></i>
                            </a>

                            <button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>

                    </div>


                    <div class="modal-body">

                        <!-- ✅ PASS TYPE + DATA -->
                        <app-certificate id="certificates" [type]="selectedCertificate?.type"
                            [data]="selectedCertificate">
                        </app-certificate>

                    </div>

                </div>
            </div>
        </div>
    </div>